/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Acrobat_LicenseInputs */

const en_pc_alt_t_acrobat_license = /** @type {(inputs: Pc_Alt_T_Acrobat_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary`)
};

const zh_pc_alt_t_acrobat_license = /** @type {(inputs: Pc_Alt_T_Acrobat_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专有软件`)
};

/**
* | output |
* | --- |
* | "Proprietary" |
*
* @param {Pc_Alt_T_Acrobat_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_acrobat_license = /** @type {((inputs?: Pc_Alt_T_Acrobat_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Acrobat_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_acrobat_license(inputs)
	return zh_pc_alt_t_acrobat_license(inputs)
});
export { pc_alt_t_acrobat_license as "pc.alt.t.acrobat.license" }